import _styled from "@emotion/styled/base";
import React from "react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { fontRoboto } from "~/lib/styles";
var FillEmailIcon = function FillEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.636 4.545v6.061c0 .384-.15.712-.45.985-.3.273-.66.409-1.08.409H1.894c-.42 0-.78-.136-1.08-.409-.3-.273-.45-.6-.45-.985v-6.06l7.65 3.09 7.622-3.09Zm0-.939L8.015 6.728.364 3.606V1.394c0-.384.15-.712.45-.985.3-.273.66-.409 1.08-.409h12.212c.42 0 .78.136 1.08.409.3.273.45.601.45.985v2.212Z",
    fill: "#fff"
  }));
};
FillEmailIcon.defaultProps = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ylzbp51"
} : {
  target: "e1ylzbp51",
  label: "Container"
})("font-size:14px;font-family:", fontRoboto, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTW1DIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IHsgZm9udFJvYm90byB9IGZyb20gXCJ+L2xpYi9zdHlsZXNcIjtcblxuaW1wb3J0IEZpbGxFbWFpbEljb24gZnJvbSBcIi4vaWNvbi1maWxsLWVtYWlsLnN2Z1wiO1xuXG5leHBvcnQgY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LWZhbWlseTogJHtmb250Um9ib3RvfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRGaWxsRW1haWxJY29uID0gc3R5bGVkKEZpbGxFbWFpbEljb24pYFxuICBtYXJnaW4taW5saW5lLWVuZDogMTJweDtcbmA7XG4iXX0= */"));
export const StyledFillEmailIcon = /*#__PURE__*/_styled(FillEmailIcon, process.env.NODE_ENV === "production" ? {
  target: "e1ylzbp50"
} : {
  target: "e1ylzbp50",
  label: "StyledFillEmailIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1o82tng",
  styles: "margin-inline-end:12px"
} : {
  name: "1o82tng",
  styles: "margin-inline-end:12px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV3dEIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IHsgZm9udFJvYm90byB9IGZyb20gXCJ+L2xpYi9zdHlsZXNcIjtcblxuaW1wb3J0IEZpbGxFbWFpbEljb24gZnJvbSBcIi4vaWNvbi1maWxsLWVtYWlsLnN2Z1wiO1xuXG5leHBvcnQgY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LWZhbWlseTogJHtmb250Um9ib3RvfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRGaWxsRW1haWxJY29uID0gc3R5bGVkKEZpbGxFbWFpbEljb24pYFxuICBtYXJnaW4taW5saW5lLWVuZDogMTJweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});